import { createOfflineCompileUrlResolver } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatFeeEmployeejobModel } from 'src/app/model/cat-fee-employee-job-model';
import { ComGoalEmployeeJobModel } from 'src/app/model/com-goal-employee-job.model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatFeeEmployeeJobService } from 'src/oldApp/services/cat-fee-employee-job.service';
import { ComGoalEmployeeJobService } from 'src/oldApp/services/com-goal-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalScGoalEmployeeJobComponent } from 'src/oldApp/shared/modal-sc-goal-employee-job/modal-sc-goal-employee-job.component';

@Component({
  selector: 'app-sc-goal-employee-job',
  templateUrl: './sc-goal-employee-job.component.html',
  styleUrls: ['./sc-goal-employee-job.component.css']
})
export class ScGoalEmployeeJobComponent implements OnInit {
  // estado pagina
  public page:string='ScGoalEmployeeJob';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public goals:ComGoalEmployeeJobModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public feeEmployeeJobCatalog:CatFeeEmployeejobModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  //
  constructor(
    private scGoalService:ComGoalEmployeeJobService,
    private catEmployeeJobService:CatEmployeeJobService,
    private catFeeEmployeeJobService:CatFeeEmployeeJobService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let goal=this.creator.newComGoalEmployeeJobModel();
    let modalRef=this.modalService.open(ModalScGoalEmployeeJobComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.goal=goal;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.componentInstance.goals=this.goals;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(goal:ComGoalEmployeeJobModel)=> {
    console.log(">> Edit Goal: ", goal)
    let modalRef=this.modalService.open(ModalScGoalEmployeeJobComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.goal={...goal};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.componentInstance.goals=this.goals;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;
  feeEmployeeJob=item=> item.feeEmployeeJobId!==0?this.feeEmployeeJobCatalog.find(fee=> fee.feeEmployeeJobId===item.feeEmployeeJobId).description:'N/A';

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.scGoalService.getAll(),
      this.catEmployeeJobService.getAll(),
      this.catFeeEmployeeJobService.getAll()
    )
    .pipe(
      tap(([goalResp, empJobResp, feeResp]:[any, any, any])=> {
        if(goalResp && empJobResp && feeResp) {
          this.goals=goalResp.data;
          this.employeeJobCatalog=empJobResp.data;
          this.feeEmployeeJobCatalog=feeResp.data;
          this.viewStatus=1;

          console.log(">> Goals: ", this.goals)

        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}
